import * as C from './consts'
// import { combineReducers } from "redux";
import { boundApiReducer as api } from 'redux-upgrader'

export const countries = api(C.GET_COUNTRIES, Array)
export const regions = api(C.GET_REGIONS, Array)

export const countriesForFilter = api(C.GET_COUNTRIES_FOR_FILTER, Array)
export const regionsForFilter = api(C.GET_REGIONS_FOR_FILTER, Array)
